(function () {
  function formatMoney(cents, useCurrency, currencyCode) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currencyCode || 'USD',
        currencyDisplay: useCurrency ? 'code' : 'symbol',
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function getShopCurrency() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {
      /* noop */
    }
    return document.documentElement.getAttribute('data-shop-currency') || 'USD';
  }

  class BundleDiscountWidgetElement extends HTMLElement {
    connectedCallback() {
      this.currencyCode = getShopCurrency();
      this.useCurrency = this.getAttribute('data-use-currency') === 'true';
      this.unitPrice = parseInt(this.getAttribute('data-unit-price'), 10) || 0;
      this.minQty = parseInt(this.getAttribute('data-min-qty'), 10) || 1;
      this.increment = parseInt(this.getAttribute('data-increment'), 10) || 1;

      try {
        this.variants = JSON.parse(this.getAttribute('data-variants') || '[]');
      } catch (e) {
        this.variants = [];
      }

      this.formRoot = this.closest('product-form-component') || this.closest('form') || this.parentElement;
      this.qtyInput = this.formRoot ? this.formRoot.querySelector('input[name="quantity"]') : null;
      this.hiddenVariantInput = this.formRoot ? this.formRoot.querySelector('input[name="id"]') : null;
      this.qtyWrapper = this.formRoot
        ? this.formRoot.querySelector('.quantity-selector-wrapper, .sl-pi__qty-wrap')
        : null;

      this.radios = Array.prototype.slice.call(this.querySelectorAll('.bundle-discount-widget__radio'));
      var self = this;
      this.radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          self.applySelectedTier();
        });
      });

      if (this.qtyWrapper) {
        this.qtyWrapper.style.display = 'none';
      }

      this.applySelectedTier();

      // This theme's variant picker (buttons/swatches) does not reliably fire a
      // native 'change' event that bubbles to the form, so instead of depending
      // on an event we poll the hidden variant-id input for changes. This is
      // framework-agnostic and keeps working even if the picker markup changes.
      this.lastVariantId = this.hiddenVariantInput ? this.hiddenVariantInput.value : null;
      if (this.hiddenVariantInput) {
        this._pollTimer = window.setInterval(function () {
          if (!self.hiddenVariantInput) return;
          var currentId = self.hiddenVariantInput.value;
          if (currentId !== self.lastVariantId) {
            self.lastVariantId = currentId;
            self.handleVariantChange();
          }
        }, 400);
      }

      if (this.formRoot) {
        this.formRoot.addEventListener('change', function (event) {
          if (self.contains(event.target) || event.target === self.qtyInput) return;
          window.setTimeout(function () {
            self.handleVariantChange();
          }, 60);
        });
      }
    }

    disconnectedCallback() {
      if (this._pollTimer) {
        window.clearInterval(this._pollTimer);
      }
    }

    getSelectedOption() {
      var checked = this.radios.filter(function (radio) {
        return radio.checked;
      })[0];
      return checked ? checked.closest('.bundle-discount-widget__option') : null;
    }

    applySelectedTier() {
      var option = this.getSelectedOption();
      if (!option || !this.qtyInput) return;
      var qty = parseInt(option.getAttribute('data-qty'), 10) || this.minQty;
      this.qtyInput.value = qty;
      try {
        this.qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.qtyInput.focus({ preventScroll: true });
        this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.qtyInput.blur();
      } catch (e) {
        /* noop */
      }
    }

    handleVariantChange() {
      if (!this.hiddenVariantInput) return;
      var variantId = this.hiddenVariantInput.value;
      var variant = this.variants.filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      if (!variant) return;

      this.unitPrice = variant.price;
      this.minQty = variant.min || 1;
      this.increment = variant.increment || 1;
      this.recalculate(variant.max);
      this.applySelectedTier();
    }

    recalculate(maxQty) {
      var singleQty = this.minQty;
      var duoQty = this.minQty + this.increment;
      var trioQty = this.minQty + this.increment * 2;

      var singleTotal = this.unitPrice * singleQty;
      var duoOriginal = this.unitPrice * duoQty;
      var trioOriginal = this.unitPrice * trioQty;

      var duoTotal = duoOriginal - 1000;
      if (duoTotal < this.unitPrice) duoTotal = this.unitPrice;
      var duoSave = duoOriginal - duoTotal;

      var trioTotal = trioOriginal - 2000;
      if (trioTotal < this.unitPrice) trioTotal = this.unitPrice;
      var trioSave = trioOriginal - trioTotal;

      this.updateOption('single', singleQty, singleTotal, null, null);
      this.updateOption('duo', duoQty, duoTotal, duoOriginal, duoSave);
      this.updateOption('trio', trioQty, trioTotal, trioOriginal, trioSave);

      var self = this;
      this.radios.forEach(function (radio) {
        var option = radio.closest('.bundle-discount-widget__option');
        var qty = parseInt(option.getAttribute('data-qty'), 10);
        var disabled = !!(maxQty && qty > maxQty);
        radio.disabled = disabled;
        option.classList.toggle('bundle-discount-widget__option--disabled', disabled);
      });
    }

    updateOption(tier, qty, total, original, save) {
      var option = this.querySelector('.bundle-discount-widget__option[data-tier="' + tier + '"]');
      if (!option) return;
      option.setAttribute('data-qty', qty);

      var priceEl = option.querySelector('[data-role="price"]');
      if (priceEl) priceEl.textContent = formatMoney(total, this.useCurrency, this.currencyCode);

      var compareEl = option.querySelector('[data-role="compare-price"]');
      if (compareEl && original != null) {
        compareEl.textContent = formatMoney(original, this.useCurrency, this.currencyCode);
      }

      var saveEl = option.querySelector('[data-role="save-label"]');
      if (saveEl && save != null) {
        saveEl.textContent = 'You save ' + formatMoney(save, this.useCurrency, this.currencyCode);
      }
    }
  }

  if (!customElements.get('bundle-discount-widget')) {
    customElements.define('bundle-discount-widget', BundleDiscountWidgetElement);
  }
})();
